
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/disclaimer",
      function () {
        return require("private-next-pages/about/disclaimer/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/disclaimer"])
      });
    }
  